window.addEventListener('DOMContentLoaded', () => {
    const timerEls = document.querySelectorAll('.checkout-reservation-timer[data-reserved-until]');
    timerEls.forEach((timerEl) => {
        const countdownEl = timerEl.querySelector('[data-countdown]');
        const progressEl = timerEl.querySelector('[data-progress]');
        const { redirectUrl, reservedUntil } = timerEl.dataset;
        // reservedUntil is a Unix timestamp (seconds). Apply a 30s processing
        // buffer so the UI timer expires 30s before the actual reservation does.
        const reservedUntilMs = Number(reservedUntil) * 1000;
        const processingBufferMs = 30 * 1000;
        const countdownEnd = reservedUntilMs - processingBufferMs;

        // Clamp display to 60 s. If less than 60 s remain when the page loads,
        // use that smaller value so we never show more time than available.
        const initialRemainingMs = Math.max(0, countdownEnd - Date.now());
        const totalSeconds = Math.min(60, Math.ceil(initialRemainingMs / 1000));

        // Pin the display end to exactly totalSeconds from now so the countdown
        // starts moving immediately and never freezes at 1:00.
        const displayEnd = Date.now() + totalSeconds * 1000;

        let intervalId = null;
        let timerStopped = false;

        const stopTimer = () => {
            timerStopped = true;
            if (intervalId) {
                window.clearInterval(intervalId);
                intervalId = null;
            }
        };

        window.addEventListener('checkout:reservation-timer-stop', stopTimer);

        const update = () => {
            if (timerStopped) {
                return;
            }

            const now = Date.now();
            const displayRemainingMs = Math.max(0, displayEnd - now);
            const displaySeconds = Math.ceil(displayRemainingMs / 1000);
            const minutes = Math.floor(displaySeconds / 60);
            const seconds = displaySeconds % 60;

            if (countdownEl) {
                countdownEl.textContent = `${minutes}:${String(seconds).padStart(2, '0')}`;
            }

            if (progressEl) {
                const ratio = totalSeconds > 0
                    ? Math.max(0, Math.min(1, displayRemainingMs / (totalSeconds * 1000)))
                    : 0;
                progressEl.style.width = `${ratio * 100}%`;
            }

            // Redirect when either the display timer or the real reservation expires.
            const realRemainingMs = Math.max(0, countdownEnd - now);
            if (displayRemainingMs <= 0 || realRemainingMs <= 0) {
                stopTimer();
                if (redirectUrl) {
                    window.location.assign(redirectUrl);
                }
            }
        };

        update();
        intervalId = window.setInterval(update, 1000);
    });

    const form = document.getElementById('checkout-finish-order-form');
    if (!form) {
        return;
    }

    const isBalanceGateway = form.dataset.isBalanceGateway === 'true';
    if (!isBalanceGateway) {
        return;
    }

    const indicator = document.getElementById('checkout-finish-indicator');
    let submitting = false;
    const submitButton = form.querySelector('button[type="submit"]');

    form.addEventListener('submit', async (event) => {
        event.preventDefault();
        if (submitting) {
            return;
        }

        submitting = true;
        window.dispatchEvent(new CustomEvent('checkout:reservation-timer-stop'));
        if (indicator) {
            indicator.classList.add('spinner-overlay--show');
        }
        if (submitButton) {
            submitButton.setAttribute('disabled', 'disabled');
        }

        try {
            const response = await window.fetch(window.location.href, {
                method: 'POST',
                body: new window.FormData(form),
                credentials: 'same-origin',
                redirect: 'follow',
            });

            if (!response.ok) {
                throw new Error(`Payment request failed with status ${response.status}`);
            }

            window.location.assign(response.url || form.dataset.successUrl || window.location.href);
        // eslint-disable-next-line no-unused-vars
        } catch (error) {
            submitting = false;
            if (indicator) {
                indicator.classList.remove('spinner-overlay--show');
            }
            if (submitButton) {
                submitButton.removeAttribute('disabled');
            }
        }
    });
});
